// extracted by mini-css-extract-plugin
module.exports = {"dataList":"clinical-portal-3__DataList__dataList","actionRow":"clinical-portal-3__DataList__actionRow","removalSpinner":"clinical-portal-3__DataList__removalSpinner"};